import React from 'react';
import './LoadingSpinner.styles.scss';

const LoadingSpinner = () => {
  return <p>Loading...</p>;  // Simple text spinner, can be replaced with a CSS spinner or component
};

export default LoadingSpinner;